module.exports = __webpack_public_path__ + "static/media/eb389106-2d9d-4e60-b035-415dfdb3b123.d3191a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/eb389106-2d9d-4e60-b035-415dfdb3b123.png
// module id = 1489
// module chunks = 0